module.exports = __webpack_public_path__ + "media/Icons/CreditCard-c9b6e288.png";